import { render, staticRenderFns } from "./StreamItemBase.vue?vue&type=template&id=13188b0f"
import script from "./StreamItemBase.vue?vue&type=script&lang=js"
export * from "./StreamItemBase.vue?vue&type=script&lang=js"
import style0 from "./StreamItemBase.vue?vue&type=style&index=0&id=13188b0f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports